var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"in-ready"},[_c('p',{staticClass:"in-ready-text"},[_c('span',{staticClass:"color-orange"},[_vm._v("준비중")]),_vm._v("입니다.")])])
}]

export { render, staticRenderFns }